import React from "react";
import { withTranslation } from "react-i18next";
import { Button as Buttonn } from "@mantine/core";

import "./styles.css";

const Button = ({
  title,
  type,
  primary = false,
  width,
  fontSize,
  icon,
  onClick,
  fontWeight = "nromal",
  disable = false,
  style,
  height,
}) => {
  return (
    <Buttonn
      className="btn float-right"
      disabled={disable}
      type={type}
      onClick={onClick}
      leftIcon={icon ? <img src={require(`../../assets/${icon}.svg`)} alt="icon"/> : ""}
      style={{
        backgroundColor: primary ? "rgb(215, 77, 72)" : "white",
        border: "1px solid rgb(0,0,0,0.3)",
        color: primary ? "white" : "rgb(27, 92, 107)",
        opacity: disable ? 0.2 : 1,
        cursor: disable ? "not-allowed" : "pointer",
        alignItems: "center",
        width: width,
        height: height,
        fontSize: fontSize,
        fontWeight: fontWeight,
        ...style,
      }}
    >
      {/* {icon && (
        <img
          src={require(`../../assets/${icon}.svg`)}
          style={{ marginRight: "5px" }}
        />
      )} */}
      {title}
    </Buttonn>
  );
};

export default withTranslation()(Button);
